import React, { useEffect, useState, useRef } from 'react'
import RegisterUser from './RegisterUser'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../assets/logo.png'
// import scanner from '../assets/sot-andorid-scanner.jpeg'
import { useDispatch, useSelector } from 'react-redux'
import LogoutModal from './LogoutModal'
import SocialIcon from './SocialIcon'

const navStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');

  .lwh-nav * { box-sizing: border-box; margin: 0; padding: 0; font-family: 'Sora', sans-serif; }

  /* ── NAV BAR ── */
  .lwh-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 999;
    height: 64px;
    background: rgba(255,255,255,0.95);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid #e8eef7;
    box-shadow: 0 1px 12px rgba(15,28,46,0.07);
    display: flex; align-items: center;
    padding: 0 2rem;
    gap: 1rem;
  }

  /* LOGO */
  .lwh-logo { display: flex; align-items: center; text-decoration: none; flex-shrink: 0; }
  .lwh-logo img { height: 34px; width: auto; object-fit: contain; }

  .lwh-spacer { flex: 1; }

  /* ── DESKTOP ACTIONS ── */
  .lwh-actions {
    display: flex; align-items: center; gap: 10px;
  }

  /* TALK TO EXPERT BUTTON */
  .lwh-expert-btn {
    display: flex; align-items: center; gap: 7px;
    padding: 8px 16px; border-radius: 10px;
    border: 1.5px solid #dce4f0; background: #f7f9fc;
    color: #0f1c2e; font-size: 13px; font-weight: 600;
    cursor: pointer; transition: border-color 0.15s, background 0.15s;
    white-space: nowrap;
  }
  .lwh-expert-btn:hover { border-color: #b8cce8; background: #fff; }
  .lwh-expert-btn svg { width: 15px; height: 15px; color: #F97316; flex-shrink: 0; }

  /* PROFILE BUTTON */
  .lwh-profile-wrap { position: relative; }
  .lwh-profile-btn {
    display: flex; align-items: center; gap: 8px;
    padding: 6px 12px 6px 6px; border-radius: 12px;
    border: 1.5px solid #dce4f0; background: #fff;
    cursor: pointer; transition: border-color 0.15s, box-shadow 0.15s;
  }
  .lwh-profile-btn:hover { border-color: #b8cce8; box-shadow: 0 2px 8px rgba(15,28,46,0.08); }
  .lwh-avatar {
    width: 30px; height: 30px; border-radius: 8px;
    background: #0f1c2e; color: #fff;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700; flex-shrink: 0;
    overflow: hidden;
  }
  .lwh-avatar img { width: 100%; height: 100%; object-fit: cover; }
  .lwh-profile-name { font-size: 13px; font-weight: 600; color: #0f1c2e; max-width: 120px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .lwh-chevron { width: 15px; height: 15px; color: #9aaabb; transition: transform 0.2s; flex-shrink: 0; }
  .lwh-profile-btn.open .lwh-chevron { transform: rotate(180deg); }

  /* DROPDOWN */
  .lwh-dropdown {
    position: absolute; top: calc(100% + 10px); right: 0;
    width: 220px;
    background: #fff; border-radius: 16px;
    border: 1px solid #e8eef7;
    box-shadow: 0 8px 32px rgba(15,28,46,0.12);
    overflow: hidden;
    animation: lwh-drop-in 0.18s ease both;
    z-index: 100;
  }
  @keyframes lwh-drop-in {
    from { opacity: 0; transform: translateY(-8px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  .lwh-drop-header {
    padding: 14px 16px 12px;
    background: #f7f9fc; border-bottom: 1px solid #e8eef7;
  }
  .lwh-drop-initials {
    width: 38px; height: 38px; border-radius: 10px;
    background: #0f1c2e; color: #fff;
    font-size: 16px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 8px;
  }
  .lwh-drop-name { font-size: 13px; font-weight: 600; color: #0f1c2e; }
  .lwh-drop-sub { font-size: 11px; color: #9aaabb; margin-top: 2px; }
  .lwh-drop-item {
    display: flex; align-items: center; gap: 10px;
    padding: 11px 16px; font-size: 13px; font-weight: 500; color: #2d3748;
    text-decoration: none; transition: background 0.12s;
    cursor: pointer; border: none; background: transparent; width: 100%;
    text-align: left;
  }
  .lwh-drop-item:hover { background: #f7f9fc; color: #0f1c2e; text-decoration: none; }
  .lwh-drop-item svg { width: 16px; height: 16px; flex-shrink: 0; }
  .lwh-drop-item.danger { color: #E24B4A; }
  .lwh-drop-item.danger:hover { background: rgba(226,75,74,0.05); }
  .lwh-drop-divider { height: 1px; background: #e8eef7; margin: 0; }

  /* ── OFFCANVAS / DRAWER ── */
  .lwh-drawer-overlay {
    position: fixed; inset: 0;
    background: rgba(15,28,46,0.35);
    z-index: 1000; opacity: 0;
    animation: lwh-fade-in 0.2s ease forwards;
  }
  @keyframes lwh-fade-in { to { opacity: 1; } }
  .lwh-drawer {
    position: fixed; top: 0; right: 0; bottom: 0;
    width: 340px; max-width: 100vw;
    background: #fff; z-index: 1001;
    display: flex; flex-direction: column;
    box-shadow: -8px 0 40px rgba(15,28,46,0.16);
    animation: lwh-slide-in 0.25s cubic-bezier(0.4,0,0.2,1) both;
  }
  @keyframes lwh-slide-in {
    from { transform: translateX(100%); }
    to   { transform: translateX(0); }
  }
  .lwh-drawer-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e8eef7; flex-shrink: 0;
  }
  .lwh-drawer-title { font-size: 16px; font-weight: 700; color: #0f1c2e; }
  .lwh-drawer-close {
    width: 32px; height: 32px; border-radius: 8px;
    border: none; background: #f7f9fc; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #6b7a90; transition: background 0.12s;
  }
  .lwh-drawer-close:hover { background: #e8eef7; }
  .lwh-drawer-close svg { width: 16px; height: 16px; }
  .lwh-drawer-body { flex: 1; overflow-y: auto; padding: 1.5rem; display: flex; flex-direction: column; gap: 1.25rem; }

  .lwh-contact-card {
    background: #0f1c2e; border-radius: 16px; padding: 1.25rem 1.5rem;
    position: relative; overflow: hidden;
  }
  .lwh-contact-blob {
    position: absolute; width: 140px; height: 140px; border-radius: 50%;
    background: radial-gradient(circle, rgba(249,115,22,0.2) 0%, transparent 70%);
    bottom: -30px; right: -20px; pointer-events: none;
  }
  .lwh-contact-inner { position: relative; z-index: 1; }
  .lwh-contact-title { font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 4px; }
  .lwh-contact-sub { font-size: 12px; color: rgba(255,255,255,0.5); margin-bottom: 1rem; line-height: 1.5; }
  .lwh-contact-row {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 14px; border-radius: 10px;
    background: rgba(255,255,255,0.08);
    color: #fff; font-size: 13px; font-weight: 500;
    text-decoration: none; margin-bottom: 8px;
    transition: background 0.12s;
  }
  .lwh-contact-row:hover { background: rgba(255,255,255,0.12); color: #fff; text-decoration: none; }
  .lwh-contact-row:last-child { margin-bottom: 0; }
  .lwh-contact-row svg { width: 15px; height: 15px; color: #F97316; flex-shrink: 0; }

  .lwh-scanner-card {
    background: #f7f9fc; border-radius: 14px; padding: 1.25rem;
    border: 1px solid #e8eef7; text-align: center;
  }
  .lwh-scanner-title { font-size: 13px; font-weight: 600; color: #0f1c2e; margin-bottom: 10px; }
  .lwh-scanner-img { width: 90px; height: 90px; border-radius: 10px; border: 1px solid #e8eef7; object-fit: cover; margin: 0 auto; display: block; }

  .lwh-trust-pill {
    display: flex; align-items: center; gap: 7px;
    background: rgba(52,211,153,0.08); border: 1px solid rgba(52,211,153,0.22);
    border-radius: 10px; padding: 10px 14px;
    font-size: 12px; color: #059669; font-weight: 500; line-height: 1.5;
  }
  .lwh-trust-pill svg { width: 16px; height: 16px; flex-shrink: 0; }

  /* ── MOBILE MENU BUTTON ── */
  .lwh-mobile-menu {
    display: none;
    align-items: center; gap: 8px;
    padding: 6px 12px 6px 6px;
    border: 1.5px solid #dce4f0; border-radius: 12px;
    background: #fff; cursor: pointer;
    font-family: 'Sora', sans-serif;
    font-size: 13px; font-weight: 600; color: #0f1c2e;
  }
  .lwh-mobile-avatar {
    width: 28px; height: 28px; border-radius: 7px;
    background: #0f1c2e; color: #fff;
    font-size: 12px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
  }
  .lwh-mobile-menu svg { width: 14px; height: 14px; color: #9aaabb; }

  /* ── RESPONSIVE ── */
  @media (max-width: 768px) {
    .lwh-nav { padding: 0 1rem; }
    .lwh-actions { display: none; }
    .lwh-mobile-menu { display: flex; }
  }
  @media (min-width: 769px) {
    .lwh-mobile-menu { display: none; }
  }
`;

// ── Icons ──
const IconBolt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" style={{ width: 16, height: 16 }}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 13.5 19.79 19.79 0 0 1 1 4.82 2 2 0 0 1 2.98 2.63h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 10.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 18"/>
  </svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconDashboard = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);
const IconLogout = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);
const IconChevron = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lwh-chevron">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);
const IconX = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const IconVerified = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);
const IconDownload = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z"/><polyline points="8 12 12 16 16 12"/><line x1="12" y1="8" x2="12" y2="16"/>
  </svg>
);

export default function LoginWithHeader() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [dropOpen, setDropOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileDropOpen, setMobileDropOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [journeyComplete, setJourneyComplete] = useState();
  const dropRef = useRef(null);
  const mobileDropRef = useRef(null);

  const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);
  const { loan_quote, personal_details, upload_documents } = useSelector(
    (state) => state?.customerJourneyDetails?.journeySteps
  );

  useEffect(() => {
    if (loan_quote === 1 && personal_details === 1 && upload_documents === 1) {
      setJourneyComplete(1);
    }
    if (customerDetails) setName(customerDetails.full_name);
  }, [customerDetails]);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false);
      if (mobileDropRef.current && !mobileDropRef.current.contains(e.target)) setMobileDropOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = () => {
    window.clevertap?.event.push("lje_logout", { "message": "User logged out" });
    dispatch({ type: "LOGOUT" });
    navigate('/apply-now');
  };
  const handleLogoutClick = () => { setShowLogoutModal(true); setDropOpen(false); setMobileDropOpen(false); };
  const confirmLogout = () => { setShowLogoutModal(false); handleLogout(); };

  const initials = name
    ? name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  const displayName = (name && name.toUpperCase() !== 'NULL') ? name : 'User';
  const firstName = displayName.split(' ')[0];

  return (
    <>
      <style>{navStyles}</style>

      <nav className="lwh-nav">
        {/* LOGO */}
        <Link to="/" className="lwh-logo">
          <img src={logo} alt="Logo" />
        </Link>

        <div className="lwh-spacer" />

        {/* ── DESKTOP ── */}
        <div className="lwh-actions">
          <RegisterUser />

          {/* Talk to expert */}
          <button className="lwh-expert-btn" onClick={() => setDrawerOpen(true)}>
            <IconPhone /> Talk to expert
          </button>

          {/* Profile dropdown */}
          <div className="lwh-profile-wrap" ref={dropRef}>
            <button
              className={`lwh-profile-btn ${dropOpen ? 'open' : ''}`}
              onClick={() => setDropOpen(v => !v)}
            >
              <div className="lwh-avatar">
                {customerDetails?.profile_pic
                  ? <img src={customerDetails.profile_pic} alt="profile" onError={e => e.target.style.display = 'none'} />
                  : initials
                }
              </div>
              <span className="lwh-profile-name">Hi, {firstName}</span>
              <IconChevron />
            </button>

            {dropOpen && (
              <div className="lwh-dropdown">
                <div className="lwh-drop-header">
                  <div className="lwh-drop-initials">{initials}</div>
                  <div className="lwh-drop-name">{displayName}</div>
                  <div className="lwh-drop-sub">Verified account</div>
                </div>

                {/* {journeyComplete == 1 && ( */}
                  <Link to="/journey/dashboard" className="lwh-drop-item" onClick={() => setDropOpen(false)}>
                    <IconDashboard /> Dashboard
                  </Link>
                {/* )} */}

                <div className="lwh-drop-divider" />

                <button className="lwh-drop-item danger" onClick={handleLogoutClick}>
                  <IconLogout /> Sign out
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ── MOBILE MENU ── */}
        <div className="lwh-profile-wrap" ref={mobileDropRef} style={{ position: 'relative' }}>
          <button className="lwh-mobile-menu" onClick={() => setMobileDropOpen(v => !v)}>
            <div className="lwh-mobile-avatar">{initials}</div>
            {firstName}
            <IconChevron />
          </button>

          {mobileDropOpen && (
            <div className="lwh-dropdown">
              <div className="lwh-drop-header">
                <div className="lwh-drop-initials">{initials}</div>
                <div className="lwh-drop-name">{displayName}</div>
              </div>
              {journeyComplete == 1 && (
                <Link to="/journey/dashboard" className="lwh-drop-item" onClick={() => setMobileDropOpen(false)}>
                  <IconDashboard /> Dashboard
                </Link>
              )}
              <button className="lwh-drop-item" onClick={() => { setMobileDropOpen(false); setDrawerOpen(true); }}>
                <IconPhone /> Talk to expert
              </button>
              <div className="lwh-drop-divider" />
              <button className="lwh-drop-item danger" onClick={handleLogoutClick}>
                <IconLogout /> Sign out
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* ── TALK TO EXPERT DRAWER ── */}
      {drawerOpen && (
        <>
          <div className="lwh-drawer-overlay" onClick={() => setDrawerOpen(false)} />
          <div className="lwh-drawer">
            <div className="lwh-drawer-header">
              <span className="lwh-drawer-title">Talk to an expert</span>
              <button className="lwh-drawer-close" onClick={() => setDrawerOpen(false)}>
                <IconX />
              </button>
            </div>

            <div className="lwh-drawer-body">
              {/* Contact card */}
              <div className="lwh-contact-card">
                <div className="lwh-contact-blob" />
                <div className="lwh-contact-inner">
                  <div className="lwh-contact-title">We're here to help</div>
                  <div className="lwh-contact-sub">
                    Our advisors are available 7 days a week, 9:30 am – 11:30 pm to assist you with the best offers or resolve any queries.
                  </div>
                  <a href="tel:+917733866663" className="lwh-contact-row">
                    <IconPhone /> +91 7733866663
                  </a>
                  <a href="mailto:care@b4salary.com" className="lwh-contact-row">
                    <IconMail /> care@b4salary.com


                  </a>
                </div>
              </div>

              {/* Social icons */}
              <SocialIcon />

              {/* QR scanner */}
              <div className="lwh-scanner-card">
                <div className="lwh-scanner-title">📱 Scan to install the B4Salary app</div>
                {/* <img src={scanner} alt="App QR Code" className="lwh-scanner-img" /> */}
              </div>

              {/* Trust pill */}
              <div className="lwh-trust-pill">
                <IconVerified />
                Your details are 100% secure with us. We are an RBI-registered NBFC.
              </div>
            </div>
          </div>
        </>
      )}

      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={confirmLogout}
      />
    </>
  );
}